import React, { FC } from 'react';
import classNames from 'classnames';

export const Skeleton: FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('animate-pulse bg-gray-medium opacity-70', className)} />;
};
